module.exports = __webpack_public_path__ + "79c1c9c.woff2";